import DisplayError from "../component/statusComponents/displayError/displayError";
import DisplaySuccess from "../component/statusComponents/displaySuccess";
import axios from "../config/axiosConfig";
import { toast } from "react-toastify";

export async function signUp(data, action, setFormErrors) {
  const formData = new FormData();
  Object.keys(data).map((key) => {
    formData.append(`${key}`, data[`${key}`]);
  });
  await axios
    .post(`/users/create`, formData)
    .then((result) => {
      if (setFormErrors) {
        setFormErrors({});
      }
      DisplaySuccess(result?.data?.status, result?.data?.message);
      action();
    })
    .catch((error) => {
      if (setFormErrors) {
        setFormErrors(error?.response?.data?.allErrors);
      }
      DisplayError(error?.response?.data?.message?.status);
      return {};
    });
}
export async function login(email = "", password = "") {
  try {
    const response = await axios.post(
      "/users/login",
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const userData = response.data;
    console.log("userData", userData);
    localStorage.setItem("userLoginRequestID", userData?.userId);
    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("Login service error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}

export async function logout(userId = null) {
  try {
    const response = await axios.post("/users/logout", { userId });

    localStorage.clear();
    return true;
  } catch (error) {
    return false;
  }
}
export async function requestPasswordReset(email = "") {
  try {
    const response = await axios.post("/users/request-password-reset", {
      email,
    });

    const userId = response.data?.userId;
    return { success: true, userId, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("requestPasswordReset API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("requestPasswordReset API Error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe. Veuillez réessayer.",
      };
    }
  }
}

export async function resetPassword(
  userId = "",
  resetPasswordCode = "",
  newPassword = ""
) {
  try {
    const response = await axios.post("/users/reset-password", {
      userId,
      resetPasswordCode,
      newPassword,
    });

    localStorage.removeItem("userResetPwdRequestID");
    localStorage.removeItem("resetPwdCode");
    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("resetPassword API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("resetPassword API Error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe. Veuillez réessayer.",
      };
    }
  }
}

export async function getCurrentUser(token, refreshToken) {
  const response = await axios.get("/users/check-auth", {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-refresh-token": refreshToken, // ou autre méthode si tu passes token en cookie
    },
    withCredentials: true, // si tu utilises les cookies HttpOnly
  });
  return response.data.user;
}
export async function registerVisitor(data, action, setFormErrors) {
  try {
    const response = await axios.post("/users/register", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (setFormErrors) setFormErrors({});
    toast.success(response?.data?.message || "Inscription réussie !");
    action(); // Callback de redirection
  } catch (error) {
    if (setFormErrors) {
      setFormErrors(error?.response?.data?.allErrors || {});
    }
    const msg =
      error?.response?.data?.message || "Erreur lors de l'inscription.";
    toast.error(msg);
  }
}
